import axios from 'axios';

import { ChartDataMap } from 'utils/helpers/chartsDataHelpers';

export const getData = async () => {
  return new Promise<ChartDataMap[]>((resolve, reject) => {
    axios
      // .get('https://private-93fbab-iconiq.apiary-mock.com/getCompsData')
      // .get('/mockData/chartsData.json')
      .get('/api/getData')
      .then(response => {
        resolve(response.data.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};
